import React from 'react';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {BrandSiteConfiguration} from '../../../../services/configurations/config-data-sections/header.configuration';
import {observer} from 'mobx-react';
import {AppHeaderCrossBrandListBox} from "./boxes/app-header-cross-brand-list.box";
import {AppHeaderCrossBrandItemBox} from "./boxes/app-header-cross-brand-item.box";
import {CyClass} from "../../../../../common/cy-classes";
import {Check} from "@sparkware/app-utils";

export const AppHeaderCrossBrandsComponent = observer(class CrossBrandsComponent extends OrbitComponent<{}> {

  private _onBrandClick = async (brandConfig: BrandSiteConfiguration) => {

    const isAuth = this.services.user.isAuthorized;
    this.services.analytics.sendOrbitUserFlowEvent("Navigation","Header", "Cross_" + (isAuth ? "Casino_" : "") + brandConfig.text);

    await this.services.linksNavigation.navigateLink({
      linkId: brandConfig.linkId,
      marketingParams: {
        dl: brandConfig.dl
      }
    });
  };

  private _renderIcon = (brandConfig: BrandSiteConfiguration) => {

    if (Check.isEmpty(brandConfig?.icon)) {
      return null;
    }

    const Icon = this.services.theme.currentTheme.icons[brandConfig.icon];

    if (Check.isNullOrUndefined(Icon)) {
      return null;
    }

    return (
      <>
        <Icon className={`${brandConfig.linkId} cy-cross-brand-link-icon`} size={3.4} text={''} />
        {brandConfig.iconText}
      </>
    );
  };

  private _renderCrossBrandLinks(sites: BrandSiteConfiguration[]) {
    return (
      <React.Fragment>
        {
          sites.map(brandConfig =>
            <AppHeaderCrossBrandItemBox key={brandConfig.linkId}
                                        className={`${brandConfig.linkId} cy-cross-brand-link`}
                                        linkId={brandConfig.linkId}
                                        onClick={() => this._onBrandClick(brandConfig)}>
              {this._renderIcon(brandConfig)}
            </AppHeaderCrossBrandItemBox>
          )
        }
      </React.Fragment>
    );
  }

  render() {

    let crossBrandsConfig = this.services.configuration.data.header.cross_brand;

    if(!crossBrandsConfig) {
      return null;
    }

    if(!crossBrandsConfig.display) {
      return null;
    }

    return (
      <AppHeaderCrossBrandListBox className={CyClass('cy-cross-brand-list')}>
        {this._renderCrossBrandLinks(crossBrandsConfig.sites)}
      </AppHeaderCrossBrandListBox>
    );
  }
});
